import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, output } from '@angular/core';
import { IFormEdit } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-form-edit-form-general',
    templateUrl: './fi-form-edit-form-general.component.html',
    styleUrls: ['./fi-form-edit-form-general.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FiComponentsContainer, useExisting: FiFormEditFormGeneralComponent }],
    standalone: false,
})
export class FiFormEditFormGeneralComponent extends FiComponentsContainer {
    @Input() form: IFormEdit;
    @Input() selectedLanguageId: number;
    @Input() defaultLanguageId: number;
    public formChange = output<IFormEdit>();

    constructor(private formHelperService: FiFormHelperService) {
        super();
    }

    protected isFormNameRequired(): boolean {
        return this.formHelperService.isFormNameRequired(this.form.Names);
    }
}
